import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Button, Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { toast } from "react-toastify";
import { ButtonLoader, RichTextEditor } from "Components";
import { authService } from "Service/Axios";
import { FORM_BUILDER_FORM_SETTINGS_SAVE_URL } from "Constant/api";
import { uploadHandler } from "Utils";
import { DEFAULT_MODULE_TYPE, IMAGE_TYPES } from "Constant/constants";

export const StartEndScreen = ({ formDetails }) => {
  const { t } = useTranslation();
  const { formId } = useParams();

  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("welcome");
  const [formData, setFormData] = useState({
    welcomeText: "",
    startButtonText: "",
    backgroundImageURL: "",
    afterSubmissionText: "",
  });

  const {
    welcomeText,
    startButtonText,
    backgroundImageURL,
    afterSubmissionText,
  } = formData;

  useEffect(() => {
    if (formDetails && formDetails?.formSetting) {
      setFormData({
        welcomeText: formDetails?.formSetting?.welcomeText || "",
        startButtonText: formDetails?.formSetting?.startButtonText || "",
        backgroundImageURL: formDetails?.formSetting?.backgroundImageURL || "",
        afterSubmissionText:
          formDetails?.formSetting?.afterSubmissionText || "",
      });
    }
  }, [formDetails]);

  // On Change
  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.checked,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };
  const handleChangeTextEditor = (value, name) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUploadImage = async (e) => {
    setLoading(true);
    const response = await uploadHandler(
      e,
      DEFAULT_MODULE_TYPE.formBackgroundImage,
      IMAGE_TYPES
    );
    if (response && response.url) {
      setFormData((prev) => ({
        ...prev,
        backgroundImageURL: response.url,
      }));
      setLoading(false);
    }
  };

  const handleChangeTab = (tab) => {
    setActiveTab(tab);
  };

  // On Submit
  const onWelcomeScreen = async () => {
    setLoading(true);
    try {
      const payload = {
        formId,
        formSettingRequired: true,
        formSetting: {
          welcomemessage: true,
          welcomeText,
          startButtonText,
          backgroundImageURL,
          afterSubmissionText: afterSubmissionText,
          // welcomeText: "",
          // startButtonText: "",
          // backgroundImageURL: "",
        },
      };
      await authService(FORM_BUILDER_FORM_SETTINGS_SAVE_URL, "POST", payload);
      toast.success(t("common.messages.notification.success.updateForm"));
      setActiveTab("thankYou");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      }
    }
  };

  const onSaveSettings = async () => {
    setLoading(true);
    try {
      const payload = {
        formId,
        formSettingRequired: true,
        formSetting: {
          thankyoumessage: true,
          welcomeText,
          startButtonText,
          backgroundImageURL,
          afterSubmissionText: afterSubmissionText,
          // welcomeText: "",
          // startButtonText: "",
          // backgroundImageURL: "",
        },
      };
      await authService(FORM_BUILDER_FORM_SETTINGS_SAVE_URL, "POST", payload);
      toast.success(t("common.messages.notification.success.updateForm"));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      }
    }
  };
  return (
    <div className="p-3 rounded-2 bg-white height-equal border">
      <Tabs
        activeKey={activeTab}
        defaultActiveKey="welcome"
        transition={false}
        id="noanim-tab-example"
        className="tab-primary mb-3"
        onSelect={handleChangeTab}
      >
        <Tab eventKey="welcome" title={t("common.label.welcomeScreen")}>
          <div className="form-setting-row bg-light rounded-2 border p-3 mb-4">
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>{t("common.label.customText")}</Form.Label>
                  <RichTextEditor
                    value={welcomeText}
                    onChange={(value) =>
                      handleChangeTextEditor(value, "welcomeText")
                    }
                  />
                </Form.Group>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>{t("common.label.startButtonText")}</Form.Label>
                  <Form.Control
                    type="text"
                    id="start-button-text"
                    aria-describedby=""
                    name="startButtonText"
                    value={startButtonText}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="addSubtitle">
                    {t("common.label.uploadBackgroundImage")}{" "}
                    <small>({t("common.label.fileSize")} 5 MB)</small>
                  </Form.Label>
                  <div className="file-input-box bg-white border rounded">
                    <label htmlFor="file" className="d-block p-5 text-center">
                      <span className="material-symbols-outlined">
                        cloud_upload
                      </span>
                      <h5 className="mb-0">
                        <strong>{t("common.placeHolder.chooseFile")}</strong>{" "}
                        {t("common.label.or")}{" "}
                        <strong>{t("common.placeHolder.dragHere")}</strong>
                      </h5>
                      <small>{t("common.label.fileSize")} 5 MB</small>
                    </label>
                    <input
                      type="file"
                      id="file"
                      className="d-none"
                      onChange={handleUploadImage}
                    />
                  </div>
                </Form.Group>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                {!loading ? (
                  <Button variant="primary" onClick={onWelcomeScreen}>
                    {t("common.button.save")}
                  </Button>
                ) : (
                  <ButtonLoader />
                )}
              </Col>
            </Row>
          </div>
        </Tab>
        <Tab eventKey="thankYou" title={t("common.label.thankYouScreen")}>
          <div className="form-setting-row bg-light rounded-2 border p-3 mb-4">
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label> {t("common.label.submissionText")}</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="afterSubmissionText"
                    value={afterSubmissionText}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                {!loading ? (
                  <Button variant="primary" onClick={onSaveSettings}>
                    {t("common.button.save")}
                  </Button>
                ) : (
                  <ButtonLoader />
                )}
              </Col>
            </Row>
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};
